import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getContent } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import ActionType from '../../redux/reducer/globalActionType';
import API_AUTHENTICATION from '../../api/apiAuthentication';
import API_STATUS from '../../api/apiStatus';
import { CheckPermissionApi } from '../../util/permission';
import { FORCE_LOG_OUT_DESKTOP_VIEW } from '../../constants/menuPermissionConstant';

class ForceLogout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTime: 0,
            targetParameterTime: 0
        }
    }

    handleLogout = () => {
        if (this.props.userDetail.level !== ROLE_CATEGORY_CONSTANT.SUPER_ADMIN) {
            return API_STATUS.putStatusOffline(this.props.token)
                .then(res => {
                    this.handleResponseLogout();
                }).catch(err => {
                    this.handleResponseLogout();
                })
        }
        return this.handleResponseLogout();
    }

    handleResponseLogout = async () => {
        await this.props.handleLogout();
        API_AUTHENTICATION.postDataLogout(this.props.token)
        this.props.history.push(ROUTER_CONSTANT.LOGIN);
    }

    handleClearInterval = () => {
        document.addEventListener('mousemove', this.handleReset)
        document.addEventListener('keypress', this.handleReset)
    }

    handleReset = () => {
        this.setState({ currentTime: 0 })
    }

    componentDidMount() {
        this._isMounted = true;

        if (CheckPermissionApi(FORCE_LOG_OUT_DESKTOP_VIEW, this.props.userDetail.permissions)) {
            API_AUTHENTICATION.getParameterForceLogout(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({ targetParameterTime: getContent(res) * 60 })

                        this.intervalTime = setInterval(() => {
                            let newCurrentTime = this.state.currentTime + 1
                            this.setState({ currentTime: newCurrentTime })
                            if (newCurrentTime >= this.state.targetParameterTime) this.handleLogout()
                        }, 1000)

                        this.handleClearInterval()
                    }
                })
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.intervalTime);
        document.removeEventListener('mousemove', this.handleReset);
        document.removeEventListener('keypress', this.handleReset);
    }

    render() {
        return (
            <div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForceLogout));